"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHistoryLinkText = void 0;
var _i18n_1 = __importDefault(require("@i18n"));
var getHistoryLinkText = function (status) {
    switch (status) {
        case 'no decision':
            return _i18n_1.default.t('ITEM.ITEM_HISTORY_NO_DECISION');
        case 'deferred':
            return _i18n_1.default.t('ITEM.ITEM_HISTORY_AWAITING_REVIEW');
        case 'reviewable':
            return _i18n_1.default.t('ITEM.ITEM_HISTORY_AWAITING_REVIEW');
        case 'new':
            return _i18n_1.default.t('ITEM.ITEM_HISTORY_PROCESSING');
        default:
            return '';
    }
};
exports.getHistoryLinkText = getHistoryLinkText;
